globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Social = appCustomerSpace.Controllers.Social || {};

appCustomerSpace.Controllers.Social.MainController = (function (superClass) {

  utils.extend(MainController, superClass);

  function MainController() {
    return MainController.__super__.constructor.apply(this, arguments);
  }

  $.extend(MainController.prototype, {
    init: function () {
      var controller = this;
      controller.initModerationForms();
      return MainController.__super__.init.apply(this, arguments);
    },
    initModerationForms: function () {
      var controller = this;

      $(document).on('submit', '.social-post-moderation-form', function (e) {
        e.preventDefault();

        var $form = $(this);
        var $button = $form.find('button[type="submit"]');
        var originalButtonHtml = $button.html();

        $button.html('<i class="icon-spinner2 spinner"></i>').prop('disabled', true);

        $.ajax({
          url: $form.attr('action'),
          method: 'PATCH',
          data: $form.serialize(),
          dataType: 'json',
          success: function (response) {
            new PNotify({ icon: 'icon-checkmark3', title: $form.data('successMessage'), type: 'success', delay: 3000 });
          },
          error: function () {
            new PNotify({ icon: 'icon-cross2', title: $form.data('errorMessage'), type: 'error', delay: 3000 });
            $button.html(originalButtonHtml).prop('disabled', false);
          }
        });
      });
    },
    initActionCablePostsChannel: function (params) {
      var controller = this;

      if (!params.project_uniq_key) {
        return;
      }

      controller.posts_channel = App.cable.subscriptions.create({
        channel: "CustomerSpace::Social::PostsChannel",
        project_uniq_key: params.project_uniq_key
      }, {
        received: function (data) {
          switch (data.action) {
            case 'update_thumbnail':
              var $element = $(`#post_thumbnail_${data.post_uniq_key}`);

              if ($element.length) {
                var $newElement = $(data.html);
                $element.replaceWith($newElement);
                appCustomerSpace.LimitlessPlugins.initPlugins($newElement);
              }
              break;
            case 'update_modal':
              var $element = $(`#social-post-modal-${data.post_uniq_key}`);

              if ($element.length) {
                $element.find('.modal-content').replaceWith($(data.html).find('.modal-content'));
              }
              break;
            default:
              console.log('Invalid action :', data.action);
          }
        }
      });
    }
  });

  return MainController;

})(appCustomerSpace.Controllers.MainController);
